import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

export function deleteContacts(contactIds: string[]) {
  return requestApi<unknown>({
    url: withDocument('/address-book/bulk/contacts/delete'),
    method: 'POST',
    credentials: true,
    data: {
      contactIds,
    },
  }).then((response) => response.data);
}
